/**
 * @class ExampleComponent
 */

import React, { Component } from 'react'
import {
  StyledCheckboxWrapper,
  StyledTick,
  StyledCheckbox,
  SelectedStyledTick,
  PartiallySelectedStyledTick,
  DisabledStyledTick,
  DisabledSelectedStyledTick,
  DisabledPartiallySelectedStyledTick
} from './checkbox.styles'

export default class Checkbox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      boxStatus: this.props.boxStatus ? this.props.boxStatus : this.props.disableProperty === false ? 'disabled' : 'default',
      checkedProperty: this.props.boxStatus === 'selected' || this.props.boxStatus === 'partiallySelected' || this.props.boxStatus === 'disabledSelected' || this.props.boxStatus === 'disabledPartiallySelected'
    }
  }

  componentWillReceiveProps(nextProps) {
    const { boxStatus } = nextProps

    if ('boxStatus' in nextProps && (nextProps.boxStatus === 'selected' || nextProps.boxStatus === 'partiallySelected' || nextProps.boxStatus === 'disabledSelected' || nextProps.boxStatus === 'disabledPartiallySelected')) {
      this.setState({
        checkedProperty: true,
        boxStatus
      })
    } else {
      this.setState({
        checkedProperty: false,
        boxStatus
      })
    }
  }

    handleCheckBox = event => {
      event.stopPropagation()
      event.preventDefault()
      if (this.props.disableProperty) {

      } else {
        this.setState({
          checkedProperty: !this.state.checkedProperty
        })
      }
      if (typeof this.props.checkStatus === 'function') this.props.checkStatus(this.state.checkedProperty)
    }

    renderCustomCheckbox = event => {
      if (this.state.boxStatus === 'selected') {
        return <SelectedStyledTick data-testid='SelectedStyledTick' />
      } else if (this.state.boxStatus === 'partiallySelected') {
        return <PartiallySelectedStyledTick data-testid='PartiallySelectedStyledTick' />
      } else if (this.state.boxStatus === 'disabled') {
        return <DisabledStyledTick data-testid='DisabledStyledTick' />
      } else if (this.state.boxStatus === 'disabledSelected') {
        return <DisabledSelectedStyledTick data-testid='DisabledSelectedStyledTick' />
      } else if (this.state.boxStatus === 'disabledPartiallySelected') {
        return <DisabledPartiallySelectedStyledTick data-testid='DisabledPartiallySelectedStyledTick' />
      }
      return <StyledTick data-testid='StyledTick' />
    }

    render() {
      if (!this.props.disableProperty && this.state.checkedProperty) {
          if (this.props.partialCheckbox) {
            this.state.boxStatus = 'partiallySelected'
          } else {
            this.state.boxStatus = 'selected'
          }
      } else if (!this.props.disableProperty && !this.state.checkedProperty) {
        this.state.boxStatus = 'default'
      }
      
      return (
        <StyledCheckboxWrapper onClick={this.handleCheckBox}>
          <StyledCheckbox
            type='checkbox'
            name={this.props.name || 'myName'}
            value={this.props.value || 'myValue'}
            disabled={this.props.disableProperty}
            required={this.props.requiredProperty}
            checked={Boolean(this.state.checkedProperty)}
            partialCheckbox={this.props.partialCheckbox}
            onChange={this.handleCheckBox}
            data-testid='checkbox'
          />
          {this.renderCustomCheckbox()}
        </StyledCheckboxWrapper>
      )
    }
}
